<template>
  <div>
    <el-cascader
      v-if="loading"
      v-model="selOrgId"
      placeholder="输入文字搜索"
      :options="orgList"
      :props="props"
      clearable
      filterable
      :show-all-levels="false"
      style="width:100%"
      @change="changeValue"
      ref="cascader"
      :disabled="disabled"
    ></el-cascader>
  </div>
</template>
<script>
import { getReportFormManagerLevelOrgTree, getOrganizeTree, getPlanA } from "@/api/api";
import { formatDate, IsNullOrEmpty } from "@/utils/m-utils";

export default {
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    apitype: {
      type: String,
      default: "reportFormOrg" //reportFormOrg报表设计器获取组织架构     organize基础信息组织架构
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      props: {
        checkStrictly: true, //是否严格的遵守父子节点不互相关联
        emitPath: false //在选中节点改变时，是否返回由该节点所在的各级菜单的值所组成的数组，若设置 false，则只返回该节点的值
        // expandTrigger: "hover" //hover时展开菜单  由于节点过多会导致组件抖动，影响操作体验，所以还是用默认的click
      },
      selOrgId: "", //选中的组织id
      orgList: [] //组织列表
    };
  },
  methods: {
    async getReportFormManagerLevelOrgTree() {
      const jsonData = await getReportFormManagerLevelOrgTree();
      this.loading = false;
      this.props = Object.assign(this.props, {
        value: "organizeId",
        label: "organizeName",
        children: "orglist"
      });
      this.orgList = jsonData.data;
      this.$nextTick(() => {
        this.loading = true;
      });
    },
    async getOrganizeTree() {
      const jsonData = await getOrganizeTree();
      this.loading = false;
      this.props = Object.assign(this.props, {
        value: "organizeId",
        label: "organizeName",
        children: "subOrganizes"
      });
      this.orgList = [jsonData.data];
      this.$nextTick(() => {
        this.loading = true;
      });
    },
    async getPlanA() {
      const jsonData = await getPlanA();
      this.loading = false;
      this.props = Object.assign(this.props, {
        value: "organizeId",
        label: "organizeName",
        children: "subOrganizes"
      });
      this.orgList = [jsonData.data];
      this.$nextTick(() => {
        this.loading = true;
      });
    },
    changeValue(value) {
      this.$emit("input", value);
    }
  },
  mounted() {
    if (!IsNullOrEmpty(this.value)) {
      this.selOrgId = this.value;
    }
    switch (this.apitype) {
      case "reportFormOrg":
        this.getReportFormManagerLevelOrgTree();
        break;
      case "organize":
        this.getOrganizeTree();
        break;
      case "planA":
        this.getPlanA();
        break;
    }
  },
  watch: {
    value: function(nv, ov) {
      if (!IsNullOrEmpty(this.value)) {
        this.selOrgId = this.value;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/tools/drop-down-organize-tree.vue